<template>
  <div class="copy-container">
    <div class="referral-code">{{ showCode }}</div>
    <div class="copy-button copy-btn" :data-clipboard-text="referralCode" @click="handleCopy">{{ gettext('复制') }}</div>
  </div>
</template>

<script>
import { debounce } from "@/common/js/utils";
import Clipboard from "clipboard";

export default {
  name: 'CopyPanel',
  props: {
    referralCode: {
      type: String,
      default: ''
    },
    showCode: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      clipboard: null,
    }
  },
  created () {
    this.initClipBoard()
  },
  methods: {
    initClipBoard() {
      if (Clipboard.isSupported()) {
        this.clipboard = new Clipboard(".copy-btn");
      }
    },
    handleCopy: debounce(function () {
      this.$emit('handle-click-track', 'copy')
      // 显示复制成功消息
      const showSuccessToast = () => {
        const toast = this.$createToast({
          time: 1000,
          txt: this.gettext('复制成功'),
          type: 'correct',
        });
        toast.show();
      };

      // 显示复制错误消息
      const showErrorToast = () => {
        const toast = this.$createToast({
          time: 1000,
          txt: this.gettext('当前手机系统不支持自动复制'),
          type: 'error',
        });
        toast.show();
      };

      // 绑定剪贴板事件
      this.clipboard.on('success', (e) => {
        showSuccessToast();
        e.clearSelection();
      });
      this.clipboard.on('error', (e) => {
        showErrorToast();
        e.clearSelection();
      });
    }, 200),
  }
}
</script>

<style lang='stylus' scoped>
.copy-container {
  background: #f7f7f8;
  border-radius: 24px;
  padding: 24px 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 80px;
  margin-top: 18px;

  .referral-code {
    font-family: DiDiSans-Pro-Bold;
    font-size: 28px;
    color: #000;
    letter-spacing: 0;
    text-align: center;
    line-height: 28px;
    -webkit-user-select: text;
    -moz-user-select: text;
    -ms-user-select: text;
    user-select: text;
  }

  .copy-button {
    font-family: DiDiSans-Pro-Regular;
    font-size: 28px;
    color: rgba(0, 0, 0, .6);
    letter-spacing: 0;
    text-align: center;
    line-height: 28px;
    font-weight: 400;
  }
}
</style>